import React, { forwardRef, ReactNode, useImperativeHandle, useState } from 'react';
import { View } from 'react-native';
import { scale as initialScale } from '@components/frame';
import { SmallLoading } from '@components/loading';
import { PanelProps } from '@components/operatorPanel/components/panel';

export interface LoadableActionButtonHandle {
  trigger: () => void;
}

export interface LoadableActionButtonProps extends Pick<PanelProps, 'CC' | 'scale'> {
  onPress: (onActionStart: () => void) => void;
  children: (handlePress: () => void) => ReactNode;
}

const LoadableActionButton = forwardRef<LoadableActionButtonHandle, LoadableActionButtonProps>(
  ({ onPress, CC, scale = initialScale, children }, ref) => {
    const [isLoading, setIsLoading] = useState(false);

    const handlePress = () => onPress(() => setIsLoading(true));

    useImperativeHandle(ref, () => ({ trigger: handlePress }));

    if (isLoading) {
      return (
        <View
          style={{
            width: scale(336),
            height: scale(120),
            borderRadius: scale(18),
            backgroundColor: CC('Label/Light/AlwaysLight Primary'),
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <SmallLoading />
        </View>
      );
    }

    return <>{children(handlePress)}</>;
  }
);

export default LoadableActionButton;
